import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { BAGGAGE_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { postBaggage, postBaggageV2 } from '../../../../actions';
import BaggageForm from './BaggageForm';
import Content from '../../../layout/Content';

export const NewBaggage = ({ breadcrumbs, dispatchPostBaggageV2 }) => {
  const onSubmit = async (formValues) => {
    await dispatchPostBaggageV2(formValues);
  };

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Equipaje"
      subtitle="Crear un nuevo equipaje"
      content={<BaggageForm onSubmit={onSubmit} />}
    />
  );
};

const mapStateToProps = ({ BaggageUnit }) => ({
  breadcrumbs: [
    ...BaggageUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Equipajes y Excesos',
      href: BAGGAGE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

const mapDispatchToProps = {
  dispatchPostBaggage: postBaggage,
  dispatchPostBaggageV2: postBaggageV2,
};

NewBaggage.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostBaggageV2: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewBaggage);
